export const L10N = {
  ACTION_ADD: { id: 'common.action.add' },
  ACTION_NEXT: { id: 'core.action.next' },
  ACTION_CONTINUE: { id: 'core.action.continue' },
  ACTION_CONTINUE_WITHOUT_EXTRAS: { id: 'common.action.continue_without_extras' },
  ACTION_REMOVE: { id: 'common.action.remove' },
  ACTION_RESERVE: { id: 'common.action.reserve' },

  LABEL_ANYTHING_ELSE_TO_ADD: { id: 'common.label.anything_else_to_add' },
  LABEL_APPLIES_SELECTED_ROOMS: { id: 'common.label.applies_selected_rooms' },
  LABEL_APPLIES_INDIVIDUALS_RESERVATION: { id: 'common.label.applies_individuals_reservation' },
  LABEL_ENHANCED_YOUR_STAY: { id: 'common.label.enhance_your_stay' },
  LABEL_FOR_TYPE_EXTRA: { id: 'core.label.for_type_extra' },
  LABEL_FREE: { id: 'common.label.free' },
  LABEL_INCLUDED: { id: 'common.label.included' },
  LABEL_NIGHT_COUNT: { id: 'common.label.night_count' },
  LABEL_NIGHTS: { id: 'common.label.nights' },
};
